import { Region } from 'src/types/region'

import { TaxRate } from '@modules-deprecated/app/taxrates/types'

export function getTaxRateFromRegionAndValue({
  region,
  value,
  taxRates,
}: {
  region: Region | undefined
  value: number | null
  taxRates?: TaxRate[]
}): TaxRate | undefined {
  if (!region || value === null) {
    return undefined
  }

  return taxRates?.find(
    (taxRate) => taxRate.taxRateGroup === region && taxRate.rate === value && taxRate.appliesToPurchases,
  )
}
